


































































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { OrderDetails } from '@/api/paypal';
import { BASEURL } from '@/api/utils';
import { Action } from 'vuex-class';
import { mask } from '@titou10/v-mask';

@Component({
  directives: {
    mask,
  },
})
export default class CheckedOutDialog extends Vue {
  @Prop(Boolean) public readonly value!: boolean;
  @Prop(Object) public readonly details!: OrderDetails;
  @Ref('email') public form!: HTMLFormElement;
  @Ref('phone') public sms!: HTMLFormElement;
  @Action('cart/resendEmail') public resend!: (args: {checkoutId: string, email: string}) => Promise<void>;
  @Action('cart/sendText') public sendSms!: (args: {checkoutId: string, phone: string}) => Promise<void>;

  public email = '';
  public confirm = '';
  public loading = false;
  public smsload = false;
  public sent = false;
  public texted = false;
  public phone = '';
  public unmaskedPhone = '';
  public rules = [
    (v: string) => !!v || 'Required',
    (v: string) => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(v) || 'Invalid e-mail.';
    },
  ];

  private readonly url = BASEURL;

  public get show(): boolean {
    return this.value;
  }

  public set show(val: boolean) {
    this.$emit('input', val);
  }

  public mounted() {
    if (this.details != null && this.details.payer.phone) {
      this.phone = this.details.payer.phone.phone_number.national_number;
    }
  }

  public async sendText() {
    if (this.sms.validate()) {
      this.smsload = true;
      await this.sendSms({checkoutId: this.details.id, phone: '1' + this.unmaskedPhone});
      this.texted = true;
      this.smsload = false;
    }
  }

  public async sendEmail() {
    if (this.form.validate()) {
      this.loading = true;
      await this.resend({checkoutId: this.details.id, email: this.email});
      this.sent = true;
      this.loading = false;
    }
  }
}
